<template>
  <BgImageLayout
    title="Search results for: publishers, vendors, products, subscriptions, licenses, subscription periods' purchase order references, vendor invoice numbers, notes, publications"
  >
    <div class="search-results">
      <AgGridWrapper
        :key="rerenderKey"
        ref="agGrid"
        :options="gridOptions"
        class="fit"
        :infinite-scroll-request="infiniteScrollRequest"
        :update-rows-count="updateRowsCount"
        :title="`Search results for ${query}`"
      >
        <template #footerActions>
          <div class="row fit q-pr-md q-pb-md justify-end">Total Rows: {{ totalRows }}</div>
        </template>
      </AgGridWrapper>
    </div>
  </BgImageLayout>
</template>

<script>
import * as apiTo from './api'
import { gridOptions } from './gridOptions'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'

export default {
  components: {
    AgGridWrapper
  },

  mixins: [gridOptions],

  props: {
    query: String // from route
  },

  data: () => ({
    totalRows: null,
    rerenderKey: 1
  }),

  watch: {
    query() {
      this.rerenderKey++
    }
  },

  methods: {
    infiniteScrollRequest(request) {
      return apiTo.getRows({ ...request, query: this.query })
    },

    updateRowsCount(rowsCount) {
      this.totalRows = rowsCount
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'
@import '~@/styles/stylus/mixins'

styledScrollFor('>>> .ag-body-viewport.ag-layout-normal');

.ag-grid-wrapper-card {
  display grid
  grid-template-rows 50px 2px 1fr 35px
}

>>> .ag-theme-material {
  height 100%
}

>>> .table-content {
  padding 0 40px
}

>>> .ag-cell[col-id="tag"] > span {
  padding 5px
  border-radius 7px
  color white
}

>>> .ag-cell[col-id="tag"].publisher >span {
  background $accent-colour
}

>>> .ag-cell[col-id="tag"].vendor >span {
  background $lm-cyan
}

>>> .ag-cell[col-id="tag"].product >span {
  background $lm-light-green
}

>>> .ag-cell[col-id="tag"].subscription >span {
  background $lm-green
}

>>> .ag-cell[col-id="tag"].license >span {
  background $primary
}

>>> .ag-cell[col-id="tag"].subscription-period-purchase-order-reference >span {
  background : #0a4242
}

>>> .ag-cell[col-id="tag"].invoice >span {
  background : var(--r-secondary-5)
}

>>> .ag-cell[col-id="tag"].note >span {
  background : var(--r-primary-1)
}

>>> .ag-cell[col-id="tag"].publication >span {
  background : $lm-indigo
}

.search-results {
  height calc(100vh - 80px)
}
</style>
